export default __webpack_public_path__ + "static/media/home-active.99a32429.svg";